/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import styles from './SafariToolbarColorFixer.module.scss';

interface SafariToolbarColorFixerProps {
    cssColorVar: string;
}

/**
 * Forces Safari to use the specified CSS color variable for the bottom toolbar
 * by rendering a fixed position strip of the specified color.
 * Assumes the actual content is flush with the bottom of the screen, otherwise the
 * color strip might be visible in an undesirable way.
 *
 * Useful for drawers or modals that use --color-ui-03 for the bottom action buttons
 */
export function SafariToolbarColorFixer({
    cssColorVar = '--color-ui-03',
}: SafariToolbarColorFixerProps) {
    return (
        <div
            className={styles.SafariToolbarColorFixer}
            style={{ backgroundColor: `var(${cssColorVar})` }}
        />
    );
}
